import { gql } from "@apollo/client";
import { getFields, getOrderByWithSecondOrder } from "../../util/graphqlUtil";
import { QUERY_PAGE_SIZE } from "../util";
import { PagedLinjeQuery } from "../../interfaces/linje";
import { fmulinjeFields, fmulinjeKursistFields } from "./fields";

export const GET_PAGED_LINJE_QUERY = (query: PagedLinjeQuery) => {
  const { after, before, fields, filters } = query;
  const nodeFields = getFields(fields);
  const order = getOrderByWithSecondOrder(query, "nr", "ASC");

  return gql`
      query pagedFmulinjer {
        fmulinjer(
          ${before ? "last: " + QUERY_PAGE_SIZE : "first: " + QUERY_PAGE_SIZE}
          ${after ? `after: "${after}"` : before ? `before: "${before}"` : ""}
          ${filters}
          ${order}
          ) {
          totalCount
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              ${nodeFields}
              }
          }
        }
      }
    `;
};

export const GET_LINJE_BY_ID_FMULINJEKURSIST_QUERY = () => gql`
      query FMULINJEKURSIST($id: UUID!, $dato: Date!) {
        fmulinje(id: $id) {
          fmulinjeKursist {
            ${fmulinjeKursistFields}
            person {
              prioriteretEmail
              primaerPersonFirmaRelationPaa(dato: $dato) {
              periode {
                fraDato
                tilDatoInklusiv
              }
              emailArbejde
              firma {
                navn1
              }
            }
            kursusPerson{
              id
              holdId
              hold{
                fmulinje{
                    id
                }
              }
            }
          }
        }
      }
    }
  `;

export const GET_LINJE_BY_ID_QUERY = () => gql`
    query fmulinjeById($id: UUID!, $dato: Date!) {
      fmulinje(id: $id) {
        ${fmulinjeFields}
        fmulinjeKursist {
          ${fmulinjeKursistFields}
          person {
            primaerPersonFirmaRelationPaa(dato: $dato) {
              periode {
                fraDato
                tilDatoInklusiv
              }
              emailArbejde
              firma {
                navn1
              }
            }
          }
        }
      }
    }
  `;

export const GET_LINJER_IDS = (query: PagedLinjeQuery, totalCount: number) => {
  const { filters } = query;
  return gql`
    query linjeIds {
      fmulinjer(
        ${filters ? filters : ""}
        first: ${totalCount}
      ) {
        totalCount
        edges {
          node {
            id
          }
        }
      }
    }
  `;
};
